<template>
    <div class="wrapper site">
        <div class="item https"><a href="https://git.71ting.com" target="_blank">kGit</a><img src="https://git.71ting.com/img/favicon.png" alt=""></div>
        <div class="item https"><a href="https://code.71ting.com">Coding</a><img src="https://code.71ting.com/static/de41646fc402b968ca6d555fdf2da7de9554d28a/root/code/src/browser/media/favicon.ico" alt=""></div>
        <div class="item"><a href="http://api.71ting.com">API</a><img src="http://api.71ting.com/image/favicon.png" alt=""></div>
        <div class="item"><a href="http://jenkins.71ting.com">Jenkins</a><img src="http://jenkins.71ting.com/static/7f7170b6/images/jenkins.svg" alt=""></div>
        <div class="item https"><a href="https://io.71ting.com">iO</a></div>
        <div class="item https"><a href="https://www.bigk.cn">Blog</a></div>
    </div>
</template>
<script>
export default {
    name: 'site',
    props: {
        
    },
    data() {
        return {
            
        }
    },
    created() {
        
    },
    watch:{
        
    },
    methods: {
        
    }
}
</script>
<style lang="less">
@import '../../less/_var';
.site{
    display: grid;
    padding-top: var(--header-height);
    grid-template-columns: repeat(4, 25%);
    .item{
        height: 80px;
        line-height: 80px;
        text-align: center;
        background-color: #fff;
        margin: 10px;
        position: relative;
        border: 1px solid var(--border-color);
        transition: 0.5s;
        &:hover{
            transition: 0.2s;
            box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);
            animation: jump .2s forwards;
            a{
                transition: .8s cubic-bezier(0.215, 0.610, 0.355, 1);
                letter-spacing: 20px;
                text-indent: 20px;
            }
        }
        &.https{
            &:after{
                content: 'S';
                position: absolute;
                top: 0;
                right: 0;
                font-size: 12px;
                line-height: 12px;
                background-color: rgb(5, 168, 5);
                color: #fff;
                padding: 5px;
                transform: scale(.7);
            }
        }
        a{
            transition: 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 5;
        }
        img{
            width: 100%;
            height: 100%;
            object-fit: contain;
            filter: blur(10px);
            opacity: .5;
        }
    }
}
@keyframes jump {
    40%{
        // transform: translate(0, -4px);
    }
}
</style>